import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import withPermissionProtection from 'hoc/withPermissionProtection';

import Typography from 'components/CncUI/Typography';
import Loader from 'components/Loader';
import DisplayChecks from './DisplayChecks';

import useQuery from 'hooks/useQuery';
import useGetMainStatus from './hooks/useGetMainStatus';
import Logger from 'utilities/logger';

const useStyles = makeStyles(({ breakpoints }) => ({
  header: {
    marginTop: 40,
    [breakpoints.up('lg')]: {
      fontSize: 48,
      lineHeight: '56px',
    },
  },
}));

const HealthChecks = () => {
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [status, loadingStatus, errorStatus] = useGetMainStatus();
  const [checks, setChecks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const getHealthChecks = useQuery('getHealthChecks', {
    scopes: 'status:read',
    fetchPolicy: 'network-only',
    request: page => ({ page }),
    response: res => res.data.getStatusChecks || [],
  });
  const logger = Logger('Admin Health Checks');

  useEffect(() => {
    let timer = null;

    setLoading(true);
    getHealthChecks(page)
      .then(items => {
        setChecks(items);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });

    if (page === 1) {
      timer = setInterval(() => {
        getHealthChecks(1)
          .then(setChecks)
          .catch(err => setError(err.message));
      }, 300000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [page]);

  useEffect(() => {
    if (error || errorStatus) {
      const err = error || errorStatus;
      if (err.message && err.message.includes('Failed to fetch')) {
        const message = `Your pay stubs are still loading and may take up to ${
          country === 'CAN' ? 'another' : 'a'
        } minute`;
        notify({ message: message, show: true });
      }
      logger.error(err);
    }
  }, [error, errorStatus]);

  return (
    <Grid container spacing={2} direction="column">
      <Grid item xs={12} sm={9} md={6} id="HeaderTitle">
        <Typography variant="h2" className={classes.header}>
          System Status
        </Typography>
      </Grid>
      <Grid item xs={12} sm={9} mx={6}>
        {loadingStatus ? (
          <Loader message="Loading system status..." />
        ) : (
          <DisplayChecks
            checks={checks}
            status={status}
            page={page}
            setPage={setPage}
            loading={loading}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default withPermissionProtection('status:read')(HealthChecks);
